export const MapTypes = Object.freeze({
  Map: "Map",
  Satellite: "Satellite",
});

export class SwitchMapTypeControl {
  constructor(options = {}) {
    this.items = Object.values(MapTypes);
    this.onChange = options.onChange;
    this.activeType = null;
    this.defaultType = options.defaultType || this.items[0];
  }

  // eslint-disable-next-line class-methods-use-this
  getDefaultPosition() {
    const defaultPosition = "bottom-right";
    return defaultPosition;
  }

  insertControls() {
    this.container = document.createElement("div");
    this.container.classList.add("mapboxgl-ctrl");
    this.container.classList.add("mapboxgl-ctrl-group");
    this.container.classList.add("mapboxgl-ctrl-map-type-switch");
    this.container.classList.add("mapboxgl-ctrl-styles");
    this.container.classList.add("switch-map-satellite");
    this.nodes = [];

    this.items.forEach((item) => {
      const node = document.createElement("button");
      node.setAttribute("type", "button");
      node.textContent = item;

      if (item === this.defaultType) {
        node.classList.add("-active");
        this.map.on("load", () => {
          this.switchMapType(item);
        });
      }

      node.addEventListener("click", () => {
        if (node.classList.contains("-active")) return;
        [].forEach.call(this.nodes, (btn) => {
          btn.classList.remove("-active");
        });
        node.classList.add("-active");
        this.switchMapType(item);
        if (this.onChange) this.onChange(item);
      });
      this.nodes.push(node);
      this.container.appendChild(node);
    });
  }

  switchMapType(mapType) {
    if (this.activeType === mapType) return;
    const visibility = mapType === MapTypes.Satellite ? "visible" : "none";
    this.map.setLayoutProperty("satellite", "visibility", visibility);
    this.activeType = mapType;
  }

  onAdd(map) {
    this.map = map;
    this.insertControls();
    return this.container;
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}
